export default __webpack_public_path__ + "static/media/Line-red.d51817dc.svg";